<template>
  <SAuthForm
    :app-config="appConfig"
    :isAuthPage="isAuthPage"
    :isDisplayedImageAndTitle="isDisplayedImageAndTitle"
    :lang="this.$route.params.lang"
    :location="getLocation"
    termsAndConditionsPageName="terms-and-conditions"
    privacyPolicyPageName="https://www.slg.lu/en/politique-de-confidentialite/"
    @setGlobalLoading="setGlobalLoading"
    @setAuthToken="setAuthToken"
    @populateUserProfileInfo="populateUserProfileInfo"
    @redirect="redirect"
  />
</template>

<script lang="ts">
export default {
  name: 'AuthForm',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import importedAppConfig from '@/appConfig';
import { SAuthForm } from '@slg/web-customer-shared';
import { useStore, useVm, useGlobalErrorDialog } from '@/composables';

defineProps({
  isAuthPage: {
    type: Boolean,
    default: true,
  },
  isDisplayedImageAndTitle: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['onSignInSuccess']);
const store = useStore();
const vm = useVm();
const { setGlobalError } = useGlobalErrorDialog();
const appConfig = importedAppConfig;
const getLocation = computed(() => store.getters['auth/getLocation']);

function setGlobalLoading(isLoading: boolean) {
  store.commit('common/setGlobalLoading', isLoading);
}

function setAuthToken(authToken: string) {
  if (localStorage.getItem('authToken') !== authToken) {
    store.commit('auth/clearAuthTokenAndProfileInfo');
    store.commit('auth/setAuthToken', authToken);
  }
}

async function populateUserProfileInfo() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
}

async function redirect() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
  vm.$root.$emit('auth-success');
  await emit('onSignInSuccess');
}
</script>
